import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '../../lib/utils';
import type { LabelProps } from './types';

function Label({ className, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot='label'
      className={cn(
        'eye:body-m',
        'eye:select-none eye:group-data-[disabled=true]:pointer-events-none eye:group-data-[disabled=true]:opacity-50 eye:peer-disabled:cursor-not-allowed eye:peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
